export default "__VITE_ASSET__18c3adca__"